import React from 'react';
import { Observer } from 'mobx-react';
import { createUseStyles } from 'react-jss';
import { ThemeProps } from '@styles/theme';

import { SummaryPanel } from '@shared/components/SummaryPanel';
import {
    useDownloadablesUIStore
} from '@core/useStores';

import ProceduresIcon from '@assets/procedures.svg';
import { messages } from 'Download/download.messages';
import { useTheme } from '@mui/material/styles';

const useStyles = createUseStyles(() => ({
    panelWrapper: {
        marginBottom: 0,
        display: 'flex',
        justifyContent: 'center',
    },
}));

type DownloadsSummaryProps = {
    className?: string,
};

export const DownloadsSummary: React.FC<DownloadsSummaryProps> = ({ className }) => {
    const theme = useTheme<ThemeProps>();
    const styles = useStyles({ theme });

    const downloadablesUIStore = useDownloadablesUIStore();

    const renderValue = (value: number | null) => value === null ? '' : value;

    return (
        <Observer>
            {() => {
                const data = downloadablesUIStore.statistics;
                const preparedData = [
                    {
                        id: 0,
                        title: messages['downloadsSummary.total.title'],
                        text: messages['downloadsSummary.total.text'](renderValue(data)),
                        icon: ProceduresIcon,
                    }
                ];


                const title = messages['downloadsSummary.title'];

                return (
                    <div className={styles.panelWrapper}>
                        <SummaryPanel
                            className={className}
                            title={title}
                            items={preparedData}
                            hideTitle
                        />
                    </div>
                )
            }}
        </Observer>
    )
}
